export const ON_GARD_TIERS = Object.freeze([
    { id: 1, points: 100, name: "First Gard" },
    { id: 2, points: 250, name: "Gardian" },
    { id: 3, points: 400, name: "Prime Gard" },
    { id: 4, points: 600, name: "On Gard" },
]);
